<template>
  <div v-if="displayableRecommend">
    <Loading v-if="isLoading" />
    <IndexPageSection
      v-else
      :need-link="false"
      :need-to-move-link-to-bottom="false"
      :section-name="'recommend'"
      :title="recommendTitle"
    >
      <div class="recommend__lead">
        <span>{{ recommendDescription }}</span>
      </div>
      <div class="recommend__horizontal-scroll">
        <HorizontalScroll ref="recommend-horizontal" ref-name="recommend">
          <ItemBoxes
            :items="recommendedItems"
            :scrollable="false"
            @mount="onMountedItemBoxes"
            @click-item-box="onClickItemBox"
          />
        </HorizontalScroll>
      </div>
    </IndexPageSection>
  </div>
</template>
<script>
import ItemBoxes from '../../../molecules/item_boxes/ItemBoxes.vue'
import Loading from '../../../atoms/loadings/Loading.vue'
import HorizontalScroll from '../../../molecules/horizontal-scrolls/HorizontalScroll.vue'
import IndexPageSection from './IndexPageSection.vue'
import axios from 'axios'
export default {
  components: { ItemBoxes, Loading, IndexPageSection, HorizontalScroll },
  data() {
    return {
      recommendId: '',
      recommendTitle: '',
      recommendDescription: '',
      recommendedItems: [],
      isLoading: false
    }
  },
  computed: {
    displayableRecommend() {
      return !this.isLoading && this.recommendedItems.length !== 0
    }
  },
  mounted() {
    this.getRecommendItems()
  },
  methods: {
    async getRecommendItems() {
      this.isLoading = true
      try {
        const res = await axios.get('/api/v1/pickup/recommended_items', {
          params: {
            limit: 50
          }
        })
        if (res.data.data !== null) {
          const recommended = res.data.data.attributes
          this.recommendId = recommended.id
          this.recommendTitle = recommended.title
          this.recommendDescription = recommended.description
          this.recommendedItems = recommended.items.data
            .map(items => items.attributes)
            .map(item => ({
              id: item.id,
              linkUrl: `/items/${item.id}`,
              imageUrl: item.item_box_image_url,
              brandName: item.brand_name,
              itemName: item.name,
              itemPrice: item.min_price.toLocaleString(),
              isIncludingTax: item.is_including_tax,
              hasMultipleItemSkus: item.item_sku_count > 1,
              soldOut: item.sold_out
            }))
        }
      } catch (error) {
        const errorMessage =
          error.response.data.message ||
          'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
        this.$emit('error', errorMessage)
      }
      this.isLoading = false
    },
    onMountedItemBoxes() {
      this.$refs['recommend-horizontal'].initializeValues()
    },
    onClickItemBox(itemId) {
      dataLayer.push({
        event: 'select_promotion',
        recommend_area_id: this.recommendId,
        ecommerce: {
          items: [
            {
              item_id: itemId
            }
          ]
        }
      })
    }
  }
}
</script>
